module.exports = "<div>\r\n  <!--<div style=\"z-index: 500000; height: 160px\">-->\r\n  <div style=\"cursor: pointer\" *ngFor=\"let alert of alerts\" class=\"{{ cssClass(alert) }} alert-dismissable\" (click)=\"removeAlert(alert)\">\r\n    {{alert.message}}\r\n    <a class=\"close\" (click)=\"removeAlert(alert)\">&times;</a>\r\n  </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// D:/projects/passengerControlFront/passengerControlApp/src/app/components/alert/alert.component.html
// module id = ../../../../../src/app/components/alert/alert.component.html
// module chunks = main